import { makeStyles } from '../../../../styles';
const CONTENT_PADDING = 24;
const ICON_SIZE = 36;
const useStyles = makeStyles((theme) => ({
    content: {
        padding: CONTENT_PADDING,
        border: '1px solid',
        backgroundColor: theme.colors.primary.light,
        borderColor: theme.colors.primary.main,
        display: 'flex',
        flexDirection: 'row',
        '&.warning': {
            backgroundColor: theme.colors.warning.light,
            borderColor: theme.colors.warning.main,
        },
        '&.success': {
            backgroundColor: theme.colors.success.light,
            borderColor: theme.colors.success.main,
        },
        '&.error': {
            backgroundColor: theme.colors.error.light,
            borderColor: theme.colors.error.main,
        },
    },
    iconWrapper: {
        maxWidth: `${ICON_SIZE}px`,
        textAlign: 'center',
        '&.warn': {
            color: theme.colors.warning.main,
        },
        '&.success': {
            color: theme.colors.success.main,
        },
        '&.error': {
            color: theme.colors.error.main,
        },
        '&.info': {
            color: theme.colors.primary.main,
        },
        '& svg': {
            width: `${ICON_SIZE}px`,
            height: `${ICON_SIZE}px`,
        },
    },
    bodyWrapper: {
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '&.isIconShowed': {
            marginLeft: '16px',
            maxWidth: `calc(100% - ${ICON_SIZE}px)`,
        },
    },
    title: {
        color: theme.colors.text[900],
    },
    body: {
        color: theme.colors.gray[800],
        fontSize: '16px',
        marginTop: '8px',
    },
    buttonWrapper: {
        marginTop: '16px',
    },
}));
export default useStyles;
//# sourceMappingURL=BigAlert.styles.js.map